import { logAction } from '../api/logApi';

const styles = {
  videoCard: {
    display: 'flex',
    flexDirection: 'column',
    background: '#fff',
    borderRadius: '8px',
    overflow: 'hidden',
    textDecoration: 'none',
    color: 'inherit',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  videoCardThumbnail: {
    width: '100%',
    aspectRatio: '16 / 9',
    objectFit: 'cover',
  },
  videoCardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '10px 12px',
  },
  videoCardTitle: {
    margin: 0,
    fontSize: '0.9rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  videoCardChannel: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  videoCardChannelIcon: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    objectFit: 'cover',
  },
  videoCardChannelName: {
    fontSize: '0.8rem',
    color: '#555',
  },
  videoCardScore: {
    margin: 0,
    fontSize: '0.8rem',
    color: '#4b3f8f',
  },
};

function TrendingVideoCard({ video }) {
  const videoUrl = `https://www.youtube.com/watch?v=${video.videoId}`;

  const handleClick = () => {
    logAction('video_click', {
      vtuberId: video.vtuberId,
      videoId: video.videoId,
      source: 'trending',
    });
  };

  return (
    <a
      href={videoUrl}
      target="_blank"
      rel="noreferrer"
      style={styles.videoCard}
      onClick={handleClick}
    >
      <img
        style={styles.videoCardThumbnail}
        src={video.thumbnailUrl}
        alt={video.title}
      />
      <div style={styles.videoCardBody}>
        <p style={styles.videoCardTitle}>{video.title}</p>
        <div style={styles.videoCardChannel}>
          <img
            style={styles.videoCardChannelIcon}
            src={video.vtuberIconUrl}
            alt={video.vtuberName}
          />
          <span style={styles.videoCardChannelName}>{video.vtuberName}</span>
        </div>
      </div>
    </a>
  );
}

export default TrendingVideoCard;
